import React from "react"
import styles from "./Loader.module.scss"

const Loader = () => {
    return <div className={styles.Loader}>
        <i className="las la-spinner la-spin la-5x"></i>
    </div>
}

export default Loader